import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\"nw-serps__local-pack-result\n    {{if @result.isMatching \'nw-serps__result--highlighted\'}}\"\n>\n  {{@result.title}}\n</div>")